import React from 'react';
import DekorInput from '../commons/DekorInput.jsx'
import SockelFarbenSettings from './SockelFarbenSettings.jsx';
import SidebarFrame from "./SidebarFrame";

export default class DekorSettings extends SidebarFrame {
    renderTitle() {
        return I18N("Dekore");
    }

    setSockelMaterial(value) {
        const newMaterialArtikel = APP.findProduct(value);
        if(newMaterialArtikel) {
            APP.deleteMaterialsRecursive(APP.arrangement,'sockel');
            APP.arrangement.materials['sockel'] = value;
            APP.model.setDirty();
        }
    }

    renderBody() {
        const sockelFarben = APP.getMaterialsForDekorTyp("front").filter(m => m);
        const sockelEnabled = APP.arrangement.schraenke.some(s => s.sockelOption && s.sockelOption != "ohne" );

        return (
            <div className="appear">
                {APP.getDekorTypen()
                    .filter(dekortyp=>APP.getMaterialsForDekorTyp(dekortyp.Name).length>1)
                    .map((dekortyp,index)=>(
                    <DekorInput key={index}
                                label={I18N(`Welches ${dekortyp.Anzeigename} Dekor wünschen Sie?`)}
                                dekore={APP.getMaterialsForDekorTyp(dekortyp.Name)}
                                value={APP.arrangement.materials[dekortyp.Name]}
                                appear={true}
                                setValue={(value, option) => {
                                    APP.deleteMaterialsRecursive(APP.arrangement,dekortyp.Name);
                                    APP.arrangement.materials[dekortyp.Name]=value;
                                    APP.model.setDirty();
                                }}
                                />
                ))}
                {sockelEnabled && (
                    <DekorInput 
                        key={"sockelDekor"}
                        label={I18N(`Welches SockelDekor wünschen Sie?`)}
                        dekore={sockelFarben}
                        value={APP.arrangement.materials['sockel']}
                        appear={true}
                        setValue={(value, option) => {
                            this.setSockelMaterial(value);
                        }}
                    />
                )}
            </div>
        )
    }

}
